import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import React from 'react'
import { View } from 'react-native'

interface EmptyUserListViewProps {
  noUsersNote?: string
}

export function EmptyUserListView({ noUsersNote }: EmptyUserListViewProps) {
  const styles = useStyles()
  return (
    <View style={styles.container}>
      <View style={styles.card}>
        <Text style={styles.noUsersText}>{noUsersNote ?? t('noCrew')}</Text>
      </View>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    justifyContent: 'space-between',
    backgroundColor: theme.colors?.grey5,
  },

  card: {
    justifyContent: 'center',
    backgroundColor: theme.colors?.white,
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
    paddingHorizontal: 10,
    paddingVertical: 20,
    marginTop: 10,
  },
  noUsersText: {
    fontSize: 16,
  },
}))
